import React from "react";
import LogoutFunction from "../../components/logout/LogoutFunction";

const Logout = () => {
  return <LogoutFunction />;
};

export default Logout;
